import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor } from "../utils";

class ElderRayTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, appearance, labelFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const elderRayValue = currentItem && yAccessor(currentItem);

    const bullPower =
      (elderRayValue &&
        elderRayValue.bullPower &&
        displayFormat(elderRayValue.bullPower)) ||
      "n/a";
    const bearPower =
      (elderRayValue &&
        elderRayValue.bearPower &&
        displayFormat(elderRayValue.bearPower)) ||
      "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Use colors from appearance config or default colors
    const bullPowerColor = appearance?.bullPowerFill || "#4caf50";
    const bearPowerColor = appearance?.bearPowerFill || "#f44336";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-elder-ray"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>
            Elder Ray (Bull/Bear Power):{" "}
          </ToolTipTSpanLabel>
          <ToolTipTSpanLabel fill={labelFill}>Bull: </ToolTipTSpanLabel>
          <tspan fill={bullPowerColor}>{bullPower}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Bear: </ToolTipTSpanLabel>
          <tspan fill={bearPowerColor}>{bearPower}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

ElderRayTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,

  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,

  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  appearance: PropTypes.object,
  displayValuesFor: PropTypes.func,
};

ElderRayTooltip.defaultProps = {
  displayFormat: format(".2f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default ElderRayTooltip;
